import {   useState } from "react";
import { ReactComponent as FilterIcon } from "../../assets/img/filterIcon.svg";
import { useForm } from "react-hook-form";

import "./HomeTablesContainer.scss";
import { subDays } from "rsuite/esm/internals/utils/date";
import moment from "moment";
import CustomDropDown from "../UIKits/CustomDropdown/CustomDropdownWitoutControl";
import BottomSheet from "../BottomSheet/BottomSheet";
import { useVendingData } from "../../hooks/useVendingData";
import useIsMobile from "../../hooks/useIsMobile";
import VendingTable from "./VendingTable/VendingTable";
import WalletTable from "./WalletTable/WalletTable";
import { paymentMethods, paymentStatuses, walletTransactionStatuses } from "../Utils/constants";
import MobileFilterContainer from "../MobileFilterContainer/MobileFilterContainer";
import OutlineButton from "../UIKits/OutlineButton/OutlineButton";
import DateRange from "../UIKits/CustomDatePicker/DateRange";
import { useWalletData } from "../../hooks/useWalletData";
import { table } from "console";

const ReportTablesContainer = () => {
  
  const isMobile = useIsMobile();
  const [currentTable, setCurrentTable] = useState(0);
  const {  watch } = useForm({
    defaultValues: { searchText: "" },
  });
  const [showFilterBottomSheet, setShowFilterBottomSheet] = useState(false);
   const vendingDataHook = useVendingData({ 
    autoFetch: currentTable === 0, 
    pageSize: 10,
    enableFilters: true 
  });

  const walletDataHook = useWalletData({ 
    autoFetch: currentTable === 1, 
    pageSize: 10,
    enableFilters: true 
  });

    // Get active hook based on current tab
  const activeHook = currentTable === 0 ? vendingDataHook : walletDataHook;
  const { filters, pendingFilters, hasActiveFilters, updateFilters, updatePendingFilters, applyFilters, resetFilters } =
    activeHook;

  const [showCustomDateBottomSheet, setShowCustomDateBottomSheet] = useState(false);

  const searchText = watch("searchText");
  // const [filters, setFilters] = useState({});

  const optionsData = [
    {
      type: "status",
      options: paymentStatuses,
    },
    // Only show payment method for vending table
    ...(currentTable === 0 ? [{
      type: "paymentMethod",
      options: paymentMethods,
    }] : []),
    {
      type: "date",
      options: [
        { label: "Today", value: [new Date(), new Date()] },
        { label: "Yesterday", value: [subDays(new Date(), 1), new Date()] },
        { label: "Last 7 days", value: [subDays(new Date(), 6), new Date()] },
        { label: "Last 30 days", value: [subDays(new Date(), 29), new Date()] },
        { label: "Last 90 days", value: [subDays(new Date(), 89), new Date()] },
        { label: "Last 365 days", value: [subDays(new Date(), 364), new Date()] },
        { label: "Custom", value: [] },
      ],
    },
  ];

  const handleMobileFilterApply = (params: any) => {
    const dateValue = params?.date?.value as Date[];
    const startDate = dateValue
      ? moment(dateValue[0]).format("YYYY-MM-DD")
      : moment().subtract(30, "days").format("YYYY-MM-DD");
    const endDate = dateValue 
      ? moment(dateValue[1]).format("YYYY-MM-DD") 
      : moment().format("YYYY-MM-DD");

    const newFilters: any = {
      startDate,
      endDate,
      transactionStatus: params?.status?.value === -1 ? null : params?.status?.value,
    };

    // Only add payment method for vending
    if (currentTable === 0) {
      newFilters.paymentMethod = params?.paymentMethod?.value === -1 ? null : params?.paymentMethod?.value;
    }

    updatePendingFilters(newFilters);
    applyFilters();
    setShowFilterBottomSheet(false);
    setShowCustomDateBottomSheet(false);
  };

  const showCustomDateFilter = () => {
    setShowCustomDateBottomSheet(true);
  };

  const handleDesktopDateChange = (date: [Date, Date]) => {
    updateFilters({
      startDate: moment(date[0]).format("YYYY-MM-DD"),
      endDate: moment(date[1]).format("YYYY-MM-DD"),
    });
  };

  const handleDesktopStatusChange = (value: number) => {
    updateFilters({
      transactionStatus: value === -1 ? null : value,
    });
  };

  const handleDesktopPaymentMethodChange = (value: number) => {
    if (currentTable === 0) {
      vendingDataHook.updateFilters({
        paymentMethod: value === -1 ? null : value,
      });
    }
  };

  const handleTabSwitch = (tabIndex: number) => {
    setCurrentTable(tabIndex);
    
    // Refetch data for the active tab
    if (tabIndex === 0) {
      vendingDataHook.refetch();
    } else {
      walletDataHook.refetch();
    }
  };
   

  return (
    <div className="home-tables-container w-full mx-auto overflow-hidden  ">
      <div className="w-full flex justify-between items-center">
        <div className="w-full mb-3   flex gap-3">
          <>
            <OutlineButton
              label="Vending"
              filterMobileButton={true}
              onClick={() => handleTabSwitch(0)}
              className={`${currentTable === 0 ? "!bg-darkGreen !text-white" : ""}`}
            />

            <OutlineButton
              label="Wallet"
              filterMobileButton={true}
              onClick={() => handleTabSwitch(1)}
              className={`!px-6  ${currentTable === 1 ? "!bg-darkGreen !text-white" : "!bg-ashbg"}`}
            />
          </>

          {hasActiveFilters && isMobile && (
            <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-700 underline">
              Reset filters
            </button>
          )}
        </div>

        <div className="filter-search-container lg:flex-row xs:flex-col">
          <OutlineButton
            icon={<FilterIcon />}
            className="font-medium !px-2.5 !py-1.5 lg:!hidden"
            onClick={() => setShowFilterBottomSheet(true)}
          />
          <div className="large-status-filter">
            {/* <DateRange handleDateSelect={handleDateSelect} />   */}
            <DateRange handleDateSelect={handleDesktopDateChange}
             value={[new Date(filters.startDate), new Date(filters.endDate)]}
               label="Date"
              styles={{ marginTop: "-8px" }} />
          </div>

          <div className="large-status-filter">
            <CustomDropDown
              name="paymentMethod"
              options={paymentMethods}
              label="Payment Method"
              placeholder="payment method"
              className="rounded-[12px] w-[50%]"
              selectedValue={filters.paymentMethod ?? -1}
              onChange={handleDesktopPaymentMethodChange}
              // onChange={(value) =>
              //   setStatus((prev) => ({
              //     ...prev,
              //     value,
              //   }))
              // }
              // errorMessage={errors.operatorName?.value?.message}
            />
          </div>
          <div className="large-status-filter">
            <CustomDropDown
              name="status"
              options={currentTable ===0? paymentStatuses : walletTransactionStatuses}
              label="Status"
              placeholder="status"
              className="rounded-[12px] w-[50%]"
              selectedValue={filters.transactionStatus ?? -1}
              onChange={handleDesktopStatusChange}

              // errorMessage={errors.operatorName?.value?.message}
            />
          </div>
          {hasActiveFilters && !isMobile && (
            <button
              onClick={resetFilters}
              className="text-sm text-red-600 hover:text-red-700 font-medium whitespace-nowrap"
            >
              Reset
            </button>
          )}
        </div>
      </div>
      <div> {currentTable === 0 ? (
          <VendingTable vendingDataHook={vendingDataHook} showViewAll={false} />
        ) : (
          <WalletTable walletDataHook={walletDataHook} showViewAll={false} />
        )}</div>

      <BottomSheet
        title={showCustomDateBottomSheet ? "Custom Selection" : "Filter"}
        openBottomSheet={showFilterBottomSheet}
        setOpenBottomSheet={setShowFilterBottomSheet}
        onCloseAction={() => {
          showCustomDateBottomSheet && setShowCustomDateBottomSheet(false);
        }}
      >
        <MobileFilterContainer
          setShowFilterBottomSheet={setShowFilterBottomSheet}
          optionsData={optionsData}
          applyFilterAction={handleMobileFilterApply}
          customizedOptionAction={showCustomDateFilter}
        />
      </BottomSheet>
    </div>
  );
};

export default ReportTablesContainer;
